@if (isStandalone && translationService.loadError(); as message) {
  <output class="translation-status-banner">
    {{ translationService.t('diagnostics.translationLoadError', { detail: message }) }}
  </output>
}
